/**
 * The two surfaces the Explore components serve.
 *
 * - **explore** — Solutions › Explore: grounded chats; a question the
 *   documents cannot answer is simply declined.
 * - **support** — Validation › 1st line support: exactly the same chat, plus
 *   **Create a ticket** on a declined question (ADR-0031). The backend enforces
 *   it: only a `support` chat may raise a ticket.
 *
 * Each surface lists only its own chats (`GET /ai/chats?surface=`).
 */

export type ChatSurface = "explore" | "support";

export interface SurfaceConfig {
  surface: ChatSurface;
  title: string;
  description: string;
  basePath: string;
  tickets: boolean;
}

export const SURFACES: Record<ChatSurface, SurfaceConfig> = {
  explore: {
    surface: "explore",
    title: "Explore",
    description:
      "Ask questions about your collections. Every answer comes only from the documents you choose, and cites the passages it used.",
    basePath: "/solutions/explore",
    tickets: false,
  },
  support: {
    surface: "support",
    title: "1st line support",
    description:
      "Ask questions about your collections. Every answer comes only from the documents you choose, and cites the passages it used. When the documents cannot answer, you can raise a ticket for the support team.",
    basePath: "/solutions/validation/first-line-support",
    tickets: true,
  },
};
